import React, { Component } from 'react'
import { connect } from 'react-redux'

import { renderTimeOnly, renderFullDate } from '../../../utils/time'
import HoverPopup from '../../../shared/components/HoverPopup'

import { translation } from '../../../utils/helpers'

import './carorder.scss'

class CarOrder extends Component {

  constructor (props) {
    super(props)
    this.state = {

    }
    this.getVerticalScrollOffset = this.getVerticalScrollOffset.bind(this)
  }

  getVerticalScrollOffset () {
    let result = 0
    let scrollContainer = document.getElementById('app')
    if (scrollContainer !== undefined) {
      result = scrollContainer.scrollTop
    }
    return result
  }

  render () {
    let carrentalClass = 'carrental-order drag-handle-class'
    if (!this.props.order.IsClickable) carrentalClass += ' non-clickable-order'
    if (this.props.order.OrderId === -1 || !this.props.order.IsClickable) {
      carrentalClass += ' gu-nonselectable notavailable'
    } else if (this.props.order.IsCompleted) {
      carrentalClass += ' completed'
    }
    let style = {left: '0%', right: '90%'}
    if (this.props.order.FromPercent !== undefined && this.props.order.ToPercent !== undefined) {
      style = {left: this.props.order.FromPercent + '%', right: (100 - this.props.order.ToPercent) + '%'}
    }
    let contentStyle = {}
    if (this.props.order.Index !== null && this.props.order.Index > 0) {
      let top = 48 * this.props.order.Index
      top += this.props.order.Index
      carrentalClass += ' indexmoved'
      style.top = top + 'px'
      style.zIndex = this.props.order.Index
    }
    let contentWidth = 100
    if (this.props.order.BufferBefore !== null) {
      contentWidth -= this.props.order.BufferBefore.Percent
    }
    if (this.props.order.BufferAfter !== null) {
      contentWidth -= this.props.order.BufferAfter.Percent
    }
    contentStyle.width = contentWidth + '%'
    const renderContentMarkings = (item, index) => {
      let style = {left: '0%', right: '90%'}
      style = {left: item.FromPercent + '%', right: (100 - item.ToPercent) + '%'}
      let contentMarkingClass = 'contentMarking'
      switch (item.Type) {
        case 1:
          contentMarkingClass += ' yellow'
          break
        case 2:
          contentMarkingClass += ' red'
          break
      }
      return (
        <div key={index} className={contentMarkingClass} style={style} />
      )
    }
    const renderBufferBefore = () => {
      if (this.props.order.BufferBefore === null) return null
      let bufferStyle = {width: this.props.order.BufferBefore.Percent + '%'}
      return (
        <div className='bufferMargin left' style={bufferStyle}>
          {this.props.order.BufferBefore.ContentMarkings !== undefined && this.props.order.BufferBefore.ContentMarkings.map(renderContentMarkings)}
        </div>
      )
    }
    const renderBufferAfter = () => {
      if (this.props.order.BufferAfter === null) return null
      let bufferStyle = {width: this.props.order.BufferAfter.Percent + '%'}
      return (
        <div className='bufferMargin right' style={bufferStyle}>
          {this.props.order.BufferAfter.ContentMarkings !== undefined && this.props.order.BufferAfter.ContentMarkings.map(renderContentMarkings)}
        </div>
      )
    }
    const renderTime = (time, hasExtraTime) => {
      if (hasExtraTime === true) {
        return renderFullDate(time)
      } else {
        return renderTimeOnly(time)
      }
    }
    const orderOnClick = () => {
      if (!this.props.order.IsClickable) return
      if (this.props.order.OrderId !== -1) {
        this.props.router.push('/orders/' + this.props.order.OrderId)
      }
    }

    let hoverLines = []
    if (this.props.order.RegNr !== null && this.props.order.RegNr !== '') {
      hoverLines.push((<p key={this.props.order.OrderId + '_' + Math.random() + '_' + Math.random()}>{this.props.order.RegNr}</p>))
    }
    if (this.props.order.BrandName != null && this.props.order.BrandName !== '') {
      hoverLines.push((<p key={this.props.order.OrderId + '_' + Math.random() + '_' + Math.random()}>{translation(this.props.order.BrandName)}</p>))
    }
    if (this.props.order.Model !== null && this.props.order.Model !== '') {
      hoverLines.push((<p key={this.props.order.OrderId + '_' + Math.random() + '_' + Math.random()}>{this.props.order.Model}</p>))
    }
    hoverLines.push((<p key={this.props.order.OrderId + '_' + Math.random() + '_' + Math.random()}>{renderTime(this.props.order.FromDate, true)}</p>))
    hoverLines.push((<p key={this.props.order.OrderId + '_' + Math.random() + '_' + Math.random()}>{renderTime(this.props.order.ToDate, true)}</p>))
    let useClick = false
    let useHover = true
    let customHoverStyle = {}

    return (
      <div className={carrentalClass} style={style} onClick={orderOnClick.bind(this)} data-id={this.props.order.OrderId} data-fromdate={this.props.order.FromDate} data-periodid={this.props.order.CarRentalPeriodId}>
        {renderBufferBefore()}
        <div className='mainOrder'>
          <div className='content' style={contentStyle}>
            <HoverPopup UseClick={useClick} customStyle={customHoverStyle} UseHover={useHover} orderId={this.props.order.OrderId} PopupContent={hoverLines} getVerticalScrollOffset={this.getVerticalScrollOffset}>
              <div className='top'><span>{this.props.order.Text}</span></div>
              <div className='bottom'>
                <div className='left'><span>{renderTime(this.props.order.FromDate, this.props.order.HasTimeBefore)}</span></div>
                <div className='right'><span>{renderTime(this.props.order.ToDate, this.props.order.HasTimeAfter)}</span></div>
              </div>
              <div className='markings'>
                {this.props.order.ContentMarkings !== undefined && this.props.order.ContentMarkings.map(renderContentMarkings)}
              </div>
            </HoverPopup>
          </div>
        </div>
        {renderBufferAfter()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(CarOrder)



// WEBPACK FOOTER //
// ./src/app/pages/CarRentalOverview/CarOrder/index.js